<section>
  <div class="header">
    <h1>Round And Clinics</h1>
  </div>
  <div class="body">

    <table>
      <thead>
        <tr>
          <th style="width: 15%;">Rounds</th>
          <th style="width: 45%;">Note</th>
          <th style="width: 25%;">Doctor</th>
        </tr>
      </thead>

      <tbody *ngFor="let roundand of roundandclinic; let i = index">
            <tr *ngIf="i === 0 || roundand.date !== roundandclinic[i - 1].date">
              <td colspan="3" class="date-row" style="background-color: rgb(66, 66, 67);color: white;">
                {{ roundand.date }}
              </td>
            </tr>


            <tr>
              <td [ngClass]="getColorClass(roundand.notetype)">
                {{ roundand.notetype }}
              </td>
              <td [ngClass]="getColorClass(roundand.notetype)">
                {{ roundand.note }}
              </td>
              <td [ngClass]="getColorClass(roundand.notetype)">
                {{ roundand.extra }}
              </td>
            </tr>

      </tbody>
    </table>


  </div>
</section>
